const isBrowserOnline = ()=>{
    try {
        return "u" > typeof window && false !== window.navigator.onLine;
    } catch  {
        return false;
    }
};
const isStatusZeroFailureCircuitBreakerTripped = (consecutiveStatusZeroFailures, maxConsecutiveStatusZeroFailures)=>consecutiveStatusZeroFailures >= maxConsecutiveStatusZeroFailures && isBrowserOnline();
const updateStatusZeroFailureCount = (statusCode, consecutiveStatusZeroFailures, maxConsecutiveStatusZeroFailures, onCircuitBreakerTripped)=>{
    if (0 === statusCode) {
        if (isBrowserOnline()) {
            const updatedConsecutiveStatusZeroFailures = consecutiveStatusZeroFailures + 1;
            if (updatedConsecutiveStatusZeroFailures === maxConsecutiveStatusZeroFailures) onCircuitBreakerTripped();
            return updatedConsecutiveStatusZeroFailures;
        }
        return consecutiveStatusZeroFailures;
    }
    return 0;
};
export { isStatusZeroFailureCircuitBreakerTripped, updateStatusZeroFailureCount };
